export const GOOGLE_MAP_URL = 'https://www.google.com/maps/search/?api=1&query=';
export const SAVE_PROPERTY_URL = '/loyalty/myAccount/saveProperties.mi';
export const SIGNIN_URL = '/sign-in.mi';

export const LOCALE_SUBDIRECTORY_MAPPING: Record<string, string> = {
  'ar-AE': '/ar',
  'da-DK': '/da',
  'de-DE': '/de',
  'en-GB': '/en-gb',
  'en-US': '/en-us',
  'el-GR': '/el',
  'es-ES': '/es',
  'fi-FI': '/fi',
  'fr-FR': '/fr',
  'hi-IN': '/hi',
  'id-ID': '/id',
  'it-IT': '/it',
  'ja-JP': '/ja',
  'ko-KR': '/ko',
  'nb-NO': '/no',
  'nl-NL': '/nl',
  'pl-PL': '/pl-pl',
  'pt-BR': '/pt-br',
  'pt-PT': '/pt',
  'ru-RU': '/ru',
  'sv-SE': '/sv',
  'th-TH': '/th',
  'tr-TR': '/tr-tr',
  'vi-VN': '/vi',
  'zh-CN': '/cn',
  'zh-TW': '/zh-hk',
};
export const CUSTOM_EVENTS_CONSTANTS = {
  ON_SHOW_RATE_DETAIL: 'showRateDetailModal',
  ON_SHOW_ROOM_DETAIL: 'showRoomDetailModal',
  ON_SHOW_HOTEL_DETAIL: 'showHotelDetailModal',
  ON_SHOW_SESSION_TIMEOUT: 'showSessionTimeOutModal',
  ON_GRAPHQL_ERROR: 'UXLcallError',
  ON_SHOW_CONFIRM_CHANGES: 'showConfirmChangesModal',
  ON_CLOSE_RLM_MODAL: 'closeRLMModal',

  /* The event that would be triggered when rewards number is responded from /cnInlineEnrollment */
};
export const constants = {
  ORDER_TYPE: 'order',
  CART_TYPE: 'cart',
  COUNT: 'count',
  DEFAULT: 'default',
  DEFAULT_COUNTRY: 'US',
  DEFAULT_CURRENCY: 'USD',
  COUNTRY_CODE_USA: 'USA',
  DEFAULT_LANGUAGE: 'en-US',
  TRADITIONAL_CHINESE_LOCALE: 'zh_TW',
  INDONESIA_DEFAULT_LOCALE: 'in_ID',
  INDONESIA_LOCALE: 'id-ID',
  IS_LOCALE_ZH_TW: 'zh-TW',
  IS_LOCALE_THAI: 'th',
  IS_LOCALE_ARABIC: 'ar',
  IS_LOCALE_HEBREW: 'he',
  IS_LOCALE_VIETNAMESE: 'vi',
  IS_LOCALE_INDONESIA: 'id',
  FIRST_CHAR_CAPS: ['es', 'pt', 'ru'],
  BUDDHIST_YEAR_VALUE: 543,
  X_REQUESTED_BY_OSD: 'xRequestedByOsd',
  // OTP validation modal constants
  HOTEL_DETAILS_ID: 'showHotelDetailModal',
  SESSION_TIMEOUT_ID: 'showSessionTimeOutModal',
};
